import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import QuickReply from '../QuickReply';
import { Trans } from 'react-i18next';
import styles from './List.module.scss';
const List = ({ items, departmentsList, onClicked, loading }) => {
    if (loading)
        return React.createElement(LoadingOutlined, null);
    if (items.length === 0) {
        return (React.createElement("div", { className: styles.listEmpty },
            React.createElement(Trans, { i18nKey: "noQuickReplies" })));
    }
    return (React.createElement("div", { className: styles.container }, items.map((item) => (React.createElement("div", { className: styles.listItemContainer, key: item._id },
        React.createElement(QuickReply, { quickReply: item, departmentsList: departmentsList, onClicked: () => (onClicked ? onClicked(item) : null) }))))));
};
export default List;
